const addressFields = ['city', 'countryCode', 'zipCode', 'streetName', 'streetNumber', 'state']

type AddressType = {
  city: string
  state: string
  streetName: string
  streetNumber: string
  zipCode: string
  countryCode: string
}

export const formatAddressData = (data: any): any =>
  Object.keys(data).reduce((finalObject, key) => {
    if (addressFields.includes(key)) {
      if (finalObject.address) {
        // eslint-disable-next-line no-param-reassign
        finalObject.address = {
          ...finalObject.address,
          [key]: data[key],
        }
      } else {
        // eslint-disable-next-line no-param-reassign
        finalObject = {
          // @ts-expect-error to obe fixd
          address: {
            [key]: data[key],
          },
          ...finalObject,
        }
      }
    } else {
      // eslint-disable-next-line no-param-reassign
      finalObject = {
        ...finalObject,
        [key]: data[key],
      }
    }
    return finalObject
  }, {} as {address?: AddressType})
